import { render, staticRenderFns } from "./RepairRegistrationTabs.vue?vue&type=template&id=48b8fbe1&scoped=true"
import script from "./RepairRegistrationTabs.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8fbe1",
  null
  
)

export default component.exports